import { onlyDigits } from "./onlyDigits"

/**
 * Telefone mascarado para exibir no pós-pagamento:
 * "48996710304" | "(48) 99671-0304" | "5548996710304" -> "(48) 9····-0304".
 * Devolve "" quando não é celular brasileiro (DDD + 9 + 8 dígitos).
 */
export const maskWhatsapp = (phone: string | null | undefined): string => {
  const digits = onlyDigits(String(phone ?? ""))
  if (!/^[1-9]{2}9\d{8}$/.test(digits)) return ""
  return `(${digits.slice(0, 2)}) 9····-${digits.slice(-4)}`
}

/**
 * Celular completo para exibir no pós-pagamento:
 * "48996710304" | "5548996710304" -> "(48) 99671-0304".
 * Devolve "" quando não é celular brasileiro (DDD + 9 + 8 dígitos).
 */
export const formatWhatsapp = (phone: string | null | undefined): string => {
  if (!maskWhatsapp(phone)) return ""
  const digits = onlyDigits(String(phone ?? "")).slice(-11)
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
}
